import Accordion from '@/common/components/Accordion'
import { BranchConsumptionRestriction } from '@/features/privateCompanies/components/showBranch/consumptionRestriction/branchConsumptionRestriction'
import { ProductCategoryConsumptionRestriction } from '@/features/privateCompanies/components/showBranch/consumptionRestriction/productCategoryConsumptionRestriction'
import { RestrictionData } from '@/features/privateCompanies/types/companyBranches.type'

export const ConsumptionRestriction = ({ restriction }: { restriction?: RestrictionData }) => {
  return (
    <Accordion
      name="consumption_restriction"
      head={<p className="text-sm">Restrição de consumo</p>}
      body={
        <div className="flex flex-col gap-4">
          <BranchConsumptionRestriction restriction={restriction} />

          {Number(restriction?.product_category_restrictions?.length) > 0 && (
            <ProductCategoryConsumptionRestriction
              productCategoryRestrictions={restriction?.product_category_restrictions || []}
            />
          )}
        </div>
      }
    />
  )
}
